import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import {
  getExperienceBasicInfo,
  getVariationNameById,
} from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { mpVisualBuilderModSaved } from "@src/utils/mixpanel";
import { constructModificationPayload } from "@src/utils/mpUtils";

export interface TrackModSavedPayload {
  mod: EmbeddedMod;
  duplicateSource?: {
    groupId: string;
    groupName: string;
  };
}

export const trackModSaved = createAsyncThunk<void, TrackModSavedPayload>(
  "experienceBuilder/tracking/modSaved",
  (payload, { getState }) => {
    const experienceInfo = getExperienceBasicInfo(getState());
    if (!experienceInfo) return;

    const { experienceId, experienceName, experienceType } = experienceInfo;
    const getVariationName = getVariationNameById(getState());
    const variationName = getVariationName(payload.mod.variationId);
    const modPayload = constructModificationPayload(payload.mod, variationName);
    const device = experienceBuilderSlice.selectors.getDevice(getState());

    mpVisualBuilderModSaved({
      experienceId,
      experienceName,
      experienceType,
      ...modPayload,
      builderMode: device,
      ...(payload.duplicateSource && {
        createdFromDuplicate: true,
        duplicatedFromGroupName: payload.duplicateSource.groupName,
        duplicatedFromGroupId: payload.duplicateSource.groupId,
      }),
      isAiGenerated: payload.mod.source === "ai",
    });
  }
);
